/**
 * @generated SignedSource<<ff1199528dc653582a3514214e888e86>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceSignalReceiversSetStoreIdsMutation$variables = {
  id: string;
  storeIds?: ReadonlyArray<string> | null;
};
export type WorkspaceSignalReceiversSetStoreIdsMutation$data = {
  readonly signalWorkspace: {
    readonly updateReceiverStoreIds: {
      readonly id: string;
      readonly receiverStores: ReadonlyArray<{
        readonly id: string;
      }>;
      readonly signalCount: number;
      readonly updatedAtDate: {
        readonly isoString: string;
        readonly " $fragmentSpreads": FragmentRefs<"FormattedDate">;
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"WorkspaceSignalEditMainEditedInfo_Signal">;
    };
  };
};
export type WorkspaceSignalReceiversSetStoreIdsMutation$rawResponse = {
  readonly signalWorkspace: {
    readonly updateReceiverStoreIds: {
      readonly id: string;
      readonly receiverStores: ReadonlyArray<{
        readonly id: string;
      }>;
      readonly signalCount: number;
      readonly updatedAtDate: {
        readonly __isDate: "UnzonedDate";
        readonly isoString: string;
      } | null;
      readonly updatedBy: {
        readonly id: string;
        readonly name: string;
      } | null;
    };
  };
};
export type WorkspaceSignalReceiversSetStoreIdsMutation = {
  rawResponse: WorkspaceSignalReceiversSetStoreIdsMutation$rawResponse;
  response: WorkspaceSignalReceiversSetStoreIdsMutation$data;
  variables: WorkspaceSignalReceiversSetStoreIdsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "storeIds"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "storeIds",
    "variableName": "storeIds"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "signalCount",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "Store",
  "kind": "LinkedField",
  "name": "receiverStores",
  "plural": true,
  "selections": [
    (v3/*: any*/)
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isoString",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceSignalReceiversSetStoreIdsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SignalWorkspaceMutation",
        "kind": "LinkedField",
        "name": "signalWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "SignalWorkspace",
            "kind": "LinkedField",
            "name": "updateReceiverStoreIds",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UnzonedDate",
                "kind": "LinkedField",
                "name": "updatedAtDate",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "FormattedDate"
                  }
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WorkspaceSignalEditMainEditedInfo_Signal"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WorkspaceSignalReceiversSetStoreIdsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SignalWorkspaceMutation",
        "kind": "LinkedField",
        "name": "signalWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "SignalWorkspace",
            "kind": "LinkedField",
            "name": "updateReceiverStoreIds",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UnzonedDate",
                "kind": "LinkedField",
                "name": "updatedAtDate",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isDate"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "updatedBy",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "188b278732016761d887cf909c583fc5",
    "id": null,
    "metadata": {},
    "name": "WorkspaceSignalReceiversSetStoreIdsMutation",
    "operationKind": "mutation",
    "text": "mutation WorkspaceSignalReceiversSetStoreIdsMutation(\n  $id: ID!\n  $storeIds: [ID!]\n) {\n  signalWorkspace(id: $id) {\n    updateReceiverStoreIds(storeIds: $storeIds) {\n      id\n      signalCount\n      receiverStores {\n        id\n      }\n      updatedAtDate {\n        isoString\n        ...FormattedDate\n      }\n      ...WorkspaceSignalEditMainEditedInfo_Signal\n    }\n  }\n}\n\nfragment FormattedDate on Date {\n  __isDate: __typename\n  ...useFormattedDate\n}\n\nfragment WorkspaceSignalEditMainEditedInfo_Signal on SignalWorkspace {\n  updatedBy {\n    id\n    name\n  }\n  updatedAtDate {\n    ...FormattedDate\n  }\n}\n\nfragment useFormattedDate on Date {\n  __isDate: __typename\n  isoString\n}\n"
  }
};
})();

(node as any).hash = "dc9ed99022fe4b1b0aa492f3366475c1";

export default node;
